import { AsyncAction } from '../../base-classes';
import { TrafficCamProvider } from '../providers/trafficCamProvider';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_TRAFFIC_CAMS = new AsyncAction('GET_TRAFFIC_CAMS');
export const GET_TRAFFIC_CAM_STREAM = new AsyncAction('GET_TRAFFIC_CAM_STREAM');
export const GET_TRAFFIC_CAMS_WITH_GEOJSON = new AsyncAction('GET_TRAFFIC_CAMS_WITH_GEOJSON');
export const GET_TRAFFIC_CAM_DETAIL = new AsyncAction('GET_TRAFFIC_CAM_DETAIL');

export function getTrafficCams(...params) {
    let paramsObject = {
        location: undefined,
        locationType: undefined,
        radius: undefined,
        maxCount: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        options: undefined,
        logger: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_TRAFFIC_CAMS.base,
        payload: getTrafficCamsAction(paramsObject)
    }
}

export function getTrafficCamsWithGeoJson(location, locationType, radius, maxCount, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh) {
    return {
        type: GET_TRAFFIC_CAMS_WITH_GEOJSON.base,
        payload: getTrafficCamsAction({ location, locationType, radius, maxCount, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh })
    };
}

async function getTrafficCamsAction({ location, locationType, radius, maxCount, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh }) {
    const op = new TrafficCamProvider(baseUrl, authId, secret, options, logger);
    const results = await op.getTrafficCams(location, locationType, radius, maxCount, stdParameters, verbose, refresh);
    return results;
}

export function getTrafficCamStream(cameraId, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh) {
    return {
        type: GET_TRAFFIC_CAM_STREAM.base,
        payload: getTrafficCamStreamAction(cameraId, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh)
    }
}

async function getTrafficCamStreamAction(cameraId, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh) {
    const op = new TrafficCamProvider(baseUrl, authId, secret, options, logger);
    const results = await op.getTrafficCamStream(cameraId, stdParameters, verbose, refresh);
    return results;
}

export function getTrafficCamDetail(...params) {
    let paramsObject = {
        cameraId: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        options: undefined,
        logger: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_TRAFFIC_CAM_DETAIL.base,
        payload: getTrafficCamDetailAction(paramsObject)
    };
}

async function getTrafficCamDetailAction({ cameraId, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh }) {
    const op = new TrafficCamProvider(baseUrl, authId, secret, options, logger);
    const results = await op.getTrafficCamDetail(cameraId, stdParameters, verbose, refresh);
    return results;
}
